var update = function (items, paginationData) {
    var currentPageIndex = paginationData.currentPageIndex, pageSize = paginationData.pageSize, pagesCount = paginationData.pagesCount;
    var totalPagesCount = pagesCount || Math.ceil(items.length / pageSize);
    if (currentPageIndex < 1 || currentPageIndex > totalPagesCount) {
        currentPageIndex = 1;
    }
    // we paginate only if pagesCount property was not set
    if (!pagesCount) {
        items = items.slice((currentPageIndex - 1) * pageSize, currentPageIndex * pageSize);
    }
    return {
        items: items,
        currentPageIndex: currentPageIndex,
        totalPagesCount: totalPagesCount,
        pagesCount: pagesCount,
        pageSize: pageSize
    };
};
var compare = function (oldData, newData, userAction) {
    if (!userAction) {
        // If a change in pageSize caused a change in currentPageIndex (reset to 1) then report a change
        return oldData.currentPageIndex !== newData.currentPageIndex && oldData.pageSize !== newData.pageSize;
    }
    return ((oldData.currentPageIndex !== undefined && oldData.currentPageIndex !== newData.currentPageIndex) ||
        (oldData.pageSize !== undefined && oldData.pageSize !== newData.pageSize));
};
export default {
    update: update,
    compare: compare
};
//# sourceMappingURL=utils.js.map